import PROCESS_ACTION_TYPES from './process.types';

export const PROCESS_INITIAL_STATE = {
  processList: [],
};

export const ProcessReducer = (state = PROCESS_INITIAL_STATE, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case PROCESS_ACTION_TYPES.LOAD_PROCESS: {
      return { ...state, processList: payload };
    }
    default:
      return state;
  }
};
